import { ApiPath } from "enums";
import { Delete, Get } from "utils";

const resolveCampaignCode = (campaignCode) => {
  return (
    campaignCode ||
    localStorage.getItem("campaignCode") ||
    localStorage.getItem("organizationId") ||
    ""
  );
};

export const getFieldResponsesProcessed = async ({ campaignCode, page = 1, perPage = 50 } = {}) => {
  const res = await Get(ApiPath.SurveyFieldResponsesProcessed, {
    campaignCode: resolveCampaignCode(campaignCode),
    page,
    perPage,
  });
  return res.data;
};

export const deleteFieldResponseProcessed = async ({ fieldResponseProcessedId }) => {
  const res = await Delete(
    `${ApiPath.SurveyFieldResponsesProcessed}/${encodeURIComponent(fieldResponseProcessedId)}`,
  );
  return res.data;
};
